import { useTranslation } from "react-i18next";

export default function Merken() {
  const { t } = useTranslation("schuifpui-reparatie");

  return (
    <section className="bg-white py-16 md:py-24 w-full">
      <div className="max-w-[800px] mx-auto px-4 md:px-10">
        <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-brand-text tracking-tight text-center mb-10 md:mb-14">
          {t("merken.h2")}
        </h2>
        <div className="flex flex-col gap-6 md:gap-8">
          <p className="font-geist text-base md:text-lg text-brand-text/80 leading-relaxed">
            {t("merken.p1")}
          </p>
          <p className="font-geist text-base md:text-lg text-brand-text/80 leading-relaxed">
            {t("merken.p2")}
          </p>
        </div>
      </div>
    </section>
  );
}